import { AdobeBaseEvent }          from './adobe-base-event';
import { Store }                   from 'vuex';
import { AppState }                from '@/store';
import { ServicesContainer }       from '@/services';
import { AnalyticsEventType } from '../models';
import { ChipotleUVerificationLinkClickEvent } from '@/services/analytics/events/chipotle-u-verification-link-click';

export class AdobeChipotleUVerificationLinkClickEvent extends AdobeBaseEvent {
    name = 'AdobeChipotleUVerificationLinkClickEvent';
    event = AnalyticsEventType.LinkClicked;

    constructor(
            event: ChipotleUVerificationLinkClickEvent,
            store: Store<AppState>, 
            services: ServicesContainer
    ) {
        super(store, services);
    
        this.account.specialLoyaltyStart = { value: 1 };
        
        this.web = {
            webPageDetails: {
                "language": "en-us", 
                "name": "rewards:exchange:college-program:join",
                "pageType": "modal",
                "pageViews": { "value": 1 },
                "siteRegion": "US", 
                "siteSection": "rewards"},
            webInteraction: {
                "linkClicks": { "value": 1 },
                "linkSection": "chipotle-u-verification-modal",
                "linkTitle": "VERIFY YOUR STATUS TO ENROLL",
                "name": "Verify with ID.me", 
                "type": "other"
            }
        }    
    }
}
